
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M.879.879A3 3 0 013 0h8a1 1 0 01.707.293l6 6A1 1 0 0118 7v12a3 3 0 01-3 3H3a3 3 0 01-3-3V3A3 3 0 01.879.879zM3 2a1 1 0 00-1 1v16a1 1 0 001 1h12a1 1 0 001-1V7.414L10.586 2H3z"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M11 0a1 1 0 011 1v5h5a1 1 0 110 2h-6a1 1 0 01-1-1V1a1 1 0 011-1zM4 12a1 1 0 011-1h8a1 1 0 110 2H5a1 1 0 01-1-1zM4 16a1 1 0 011-1h8a1 1 0 110 2H5a1 1 0 01-1-1zM4 8a1 1 0 011-1h2a1 1 0 010 2H5a1 1 0 01-1-1z"}})])
          )
        }
      }
    